(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-fullName"] && !Shopify.designMode) return;
  try {
    (function () {

  /* ══════════════════════════════════════════════════
     CORE HELPERS
  ══════════════════════════════════════════════════ */
  function getInput() {
    return document.querySelector('.full-name-field__input');
  }
  function getError() {
    return document.querySelector('.full-name-field__error');
  }
  function isValid() {
    var input = getInput();
    return input && input.value.trim() !== '';
  }
  function showError() {
    var input   = getInput();
    var errorEl = getError();
    if (!input) return;
    input.classList.add('full-name-field__input--error');
    input.setAttribute('aria-invalid', 'true');
    if (errorEl) errorEl.style.display = '';
    input.scrollIntoView({ behavior: 'smooth', block: 'center' });
    setTimeout(function () { input.focus(); }, 400);
  }
  function clearError() {
    var input   = getInput();
    var errorEl = getError();
    if (!input) return;
    input.classList.remove('full-name-field__input--error');
    input.removeAttribute('aria-invalid');
    if (errorEl) errorEl.style.display = 'none';
  }

  /* ══════════════════════════════════════════════════
     LAYER 1 — Patch window.fetch
     Intercepts fetch('/cart/add.js') calls
  ══════════════════════════════════════════════════ */
  var _origFetch = window.fetch;
  window.fetch = function (resource, options) {
    var url = typeof resource === 'string' ? resource
            : (resource && resource.url ? resource.url : '');
    var isAddToCart = url.indexOf('/cart/add') !== -1
                   || url.indexOf('cart/add.js') !== -1;
    if (isAddToCart && !isValid()) {
      showError();
      return Promise.reject(new Error('full-name-required'));
    }
    return _origFetch.apply(window, arguments);
  };

  /* ══════════════════════════════════════════════════
     LAYER 2 — Patch XMLHttpRequest
  ══════════════════════════════════════════════════ */
  var _origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this._aw_url = url || '';
    return _origOpen.apply(this, arguments);
  };
  var _origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    var url = this._aw_url || '';
    if ((url.indexOf('/cart/add') !== -1 || url.indexOf('cart/add.js') !== -1) && !isValid()) {
      showError();
      return;
    }
    return _origSend.apply(this, arguments);
  };

  /* ══════════════════════════════════════════════════
     LAYER 3 — Native form submit (capture phase)
  ══════════════════════════════════════════════════ */
  document.addEventListener('submit', function (e) {
    var form   = e.target;
    var action = (form.action || '').toLowerCase();
    var id     = (form.id || '').toLowerCase();
    var isProductForm = action.indexOf('/cart/add') !== -1
                     || id.indexOf('productform') !== -1
                     || id.indexOf('product-form') !== -1
                     || id.indexOf('buybuttons') !== -1;
    if (!isProductForm) return;
    if (!isValid()) {
      e.preventDefault();
      e.stopImmediatePropagation();
      showError();
    }
  }, true);

  /* ══════════════════════════════════════════════════
     LAYER 4 — Click capture (ALL buttons + Buy it now)
     Targets:
       - Add to cart submit button
       - shopify-buy-it-now-button (Buy it now)
       - Any accelerated checkout button
  ══════════════════════════════════════════════════ */
  document.addEventListener('click', function (e) {
    var el = e.target;

    /* Walk up to find a relevant button */
    var found = false;
    var node  = el;
    while (node && node !== document.body) {
      var tag  = (node.tagName || '').toLowerCase();
      var name = (node.getAttribute('name') || '').toLowerCase();
      var type = (node.getAttribute('type') || '').toLowerCase();
      var tid  = node.getAttribute('data-testid') || '';
      var cls  = (node.className || '').toString();

      var isAtc = name === 'add'
               || tid === 'standalone-add-to-cart'
               || cls.indexOf('add-to-cart-button') !== -1
               || cls.indexOf('shopify-payment-button') !== -1;

      /* Buy it now / accelerated checkout */
      var isBuyNow = tag === 'shopify-buy-it-now-button'
                  || tag === 'shopify-accelerated-checkout'
                  || cls.indexOf('shopify-payment-button__button') !== -1
                  || node.getAttribute('data-shopify') === 'payment-button';

      if (isAtc || isBuyNow) { found = true; break; }

      /* Also catch if click is inside add-to-cart-component or product-form-component */
      if (tag === 'add-to-cart-component' || tag === 'product-form-component') {
        found = true; break;
      }

      node = node.parentElement;
    }

    if (!found) return;

    if (!isValid()) {
      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();
      showError();
    }
  }, true); /* capture = true fires BEFORE custom element handlers */

  /* ══════════════════════════════════════════════════
     LAYER 5 — Disable Buy it Now button visually
     when field is empty, re-enable when filled
  ══════════════════════════════════════════════════ */
  function setBuyNowState() {
    var btns = document.querySelectorAll(
      '.shopify-payment-button__button, shopify-buy-it-now-button button, [slot="button"] button'
    );
    btns.forEach(function (btn) {
      if (!isValid()) {
        btn.setAttribute('aria-disabled', 'true');
        btn.style.pointerEvents = 'none';
        btn.style.opacity       = '0.4';
      } else {
        btn.removeAttribute('aria-disabled');
        btn.style.pointerEvents = '';
        btn.style.opacity       = '';
      }
    });
  }

  /* ══════════════════════════════════════════════════
     INPUT EVENTS
  ══════════════════════════════════════════════════ */
  function bindInputEvents() {
    var input = getInput();
    if (!input) return;

    input.addEventListener('blur', function () {
      if (!isValid()) showError(); else clearError();
      setBuyNowState();
    });
    input.addEventListener('input', function () {
      if (isValid()) clearError();
      setBuyNowState();
    });

    /* Initial state */
    setBuyNowState();
  }

  /* ══════════════════════════════════════════════════
     MIRROR — inject hidden input into actual form
     so properties[Full Name] is in the POST body
  ══════════════════════════════════════════════════ */
  function mirrorToForm() {
    var visibleInput = getInput();
    if (!visibleInput) return;

    var propName = visibleInput.getAttribute('name') || 'properties[Full Name]';

    function sync() {
      var form = document.getElementById('BuyButtons-ProductForm-{{ section.id }}')
              || document.querySelector('form[id*="BuyButtons-ProductForm"]')
              || document.querySelector('form[action*="/cart/add"]');
      if (!form) return;

      var old = form.querySelector('[data-mirror-full-name]');
      if (old) old.remove();

      var hidden   = document.createElement('input');
      hidden.type  = 'hidden';
      hidden.name  = propName;
      hidden.value = visibleInput.value.trim();
      hidden.setAttribute('data-mirror-full-name', 'true');
      form.appendChild(hidden);
    }

    visibleInput.addEventListener('input', sync);
    sync();
  }

  /* ══════════════════════════════════════════════════
     INIT
  ══════════════════════════════════════════════════ */
  function init() {
    bindInputEvents();
    mirrorToForm();

    /* Re-run mirror after short delay in case form mounts late */
    setTimeout(mirrorToForm, 500);
    setTimeout(mirrorToForm, 1500);
    setTimeout(setBuyNowState, 500);
    setTimeout(setBuyNowState, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
  } catch(e) { console.error(e); }
})();

})();
